import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconToolbox: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconToolbox"><Path d="M2.5 10.5H21.5V20.5H2.5V10.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M12.5 10.5V6.5V2.5H19.5V10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4.5 10.5V5.84286L6.5 2.5H7.5L9.5 5.84286V10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12.5 6.5H15.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconToolbox;
